module.exports = __webpack_public_path__ + "img/45-config-logs-integracao-lista.52363211.png";